/**
 * Web QRスキャナーの遅延読み込み境界
 * 初期導線ではカメラ実装を読み込まず、スキャン表示時だけ準備します。
 */

import React from "react";
import VisitorRouteLoadingFallback from "./VisitorRouteLoadingFallback";
import type { QrScannerProps } from "./QrScannerImpl";

/** QRスキャナー本体を依存パッケージと同じchunkで遅延読み込みする */
const QrScannerImplementation = React.lazy(() => import("./QrScannerImpl"));

/**
 * Web QRスキャナーを必要時に読み込む
 * @param props - QR読み取りと復旧操作
 * @returns QRスキャナーまたは読み込み表示
 */
const QrScanner = (props: QrScannerProps) => (
  <React.Suspense fallback={<VisitorRouteLoadingFallback />}>
    <QrScannerImplementation {...props} />
  </React.Suspense>
);

export default QrScanner;
